export type RecordCommentFields = {
    comment?: string | null;
    commentRecord?: string | null;
};

export function getRecordComment(record?: RecordCommentFields | null): string {
    if (!record) {
        return "";
    }

    if (Object.prototype.hasOwnProperty.call(record, "commentRecord")) {
        return typeof record.commentRecord === "string" ? record.commentRecord.trim() : "";
    }

    return typeof record.comment === "string" ? record.comment.trim() : "";
}
